import React from 'react';

const InitialMessage = (props) => {
  const { selected, message } = props;
  if (selected) return null;

  return (
    <div className="message px-4">
      {message}
    </div>
  );
};

InitialMessage.defaultProps = {
  message: Spree.translations.initial_message,
  selected: false,
};

export default InitialMessage;
